import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { AbstractControl, ControlContainer, NgControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {
  controlStatusChanges$,
  getAllFormControls,
} from '../../../shared/utils/form-control/form-control.utils';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
  standalone: true,
})
export class FormErrorComponent implements OnInit {
  errorMessage$!: Observable<string>;
  controls: AbstractControl[] = [];

  private readonly controlContainer = inject(ControlContainer);
  private readonly ngControl = inject(NgControl);

  ngOnInit(): void {
    this.loadControls();
    this.loadErrorMessage();
  }

  private loadControls(): void {
    if (this.ngControl.control) {
      this.controls = getAllFormControls(this.ngControl.control);
    } else if (this.ngControl.name) {
      this.controls = getAllFormControls(
        this.controlContainer.control?.get(this.ngControl.name.toString()),
      );
    } else {
      this.controls = getAllFormControls(this.controlContainer.control);
    }
  }

  private loadErrorMessage(): void {
    this.errorMessage$ = controlStatusChanges$(...this.controls).pipe(
      startWith(''),
      map(() =>
        this.controls.find(
          (control: AbstractControl) =>
            control.invalid && control.touched && control.errors,
        ),
      ),
      map(
        (invalidControl: AbstractControl | undefined) =>
          Object.values(invalidControl?.errors ?? {})[0],
      ),
    );
  }
}
